import React, { Component } from 'react'
import { Link } from 'react-router'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import style from '../style.module.less'
import store from '../store'
import { Button, Select } from 'hljd'

@observer
export default class extends Component {
  componentDidMount() {
    store.getLiveBuyInfo()
  }

  render() {
    const { liveBalance, liveProtocol, adid, buyInfo } = store
    return (
      <div className={style.form}>
        <div className={style.balance}>
          <div className={style.label}>账户余额</div>
          <p>¥{liveBalance}</p>
          <Link to="/localMerchant/liveManage/ExpenseDetail">查看消费明细</Link>
        </div>
        <div className={style.charge}>
          <div className={style.label}>账户充值</div>
          <Select
            className={style.charge_select}
            value={toJS(adid)}
            onChange={store.changeParams}
            placeholder="请选择充值金额"
          >
            {toJS(buyInfo).map(item => {
              return (
                <Select.Option
                  className={style.charge_select_option}
                  value={item.adid + ''}
                  key={item.adid}
                >
                  ￥<span className={style.price}>{item.price}</span>
                </Select.Option>
              )
            })}
          </Select>
        </div>
        <Button onClick={store.rechargeValidate(liveProtocol)}>充值</Button>
      </div>
    )
  }
}
